import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { pageApiSlice } from '../pageApi';
import { updateTaskResult, clearPage, setPageData } from '../pageState';

export const useUpdateTaskResult = () => {
  const dispatch = useDispatch();
  return useCallback((taskResult) => {
    dispatch(updateTaskResult(taskResult));
  }, [dispatch]);
};

export const useClearPage = () => {
  const dispatch = useDispatch();
  return useCallback(() => {
    dispatch(clearPage());
  }, [dispatch]);
};

export const useSetPageData = () => {
  const dispatch = useDispatch();
  return useCallback((pageData) => {
    dispatch(setPageData(pageData));
  }, [dispatch]);
};

// RTKQ hooks - direct exports (no unnecessary wrappers)
export const useGetPageByIdQuery = pageApiSlice.useGetPageByIdQuery;
export const useMarkPageAsViewedMutation = pageApiSlice.useMarkPageAsViewedMutation;
